import TreatmentPage from "./TreatmentPage";

export default function CarbonLaserFacial() {
  return (
    <TreatmentPage
      title="Carbon Laser Facial"
      heroImage="/Treatment/carbon-facial-drTruptis-clinic.png"

      intro="Carbon Laser Facial is an advanced non-invasive skin rejuvenation treatment that deeply cleanses, exfoliates, and refreshes the skin using medical-grade laser technology. A thin layer of medical carbon is applied to the skin, which absorbs impurities and oil, and is then targeted by a laser to remove dead skin cells and stimulate collagen production."

      description="This treatment is popular for improving oily skin, acne, enlarged pores, dull skin, and uneven skin tone. It helps give the skin a brighter, smoother, and more youthful appearance with minimal downtime."

      howItWorks="A medical carbon lotion is first applied to the face which penetrates deep into the pores. The laser is then passed over the skin, targeting the carbon particles. As the carbon absorbs oil, dirt, and dead skin cells, the laser energy gently destroys it, removing impurities and stimulating collagen production for healthier skin."

      benefits={[
        "Deeply cleans and tightens pores.",
        "Reduces acne and oily skin.",
        "Improves skin texture and tone.",
        "Removes dead skin cells.",
        "Brightens dull and tired skin.",
        "Stimulates collagen for smoother skin."
      ]}

      beforeAfterImages={[
        "/Treatment/before-carbon-laser-facial.jpg",
        "/Treatment/after-carbon-laser-facial.jpg",
      ]}

      faqs={[
        { q: "Is Carbon Laser Facial painful?", a: "No, it is a comfortable procedure and most patients feel only a mild warming sensation." },
        { q: "Is there any downtime?", a: "There is minimal to no downtime, and you can return to normal activities immediately." },
        { q: "How many sessions are required?", a: "Usually 3–5 sessions are recommended depending on skin concerns." },
        { q: "Who can take this treatment?", a: "It is suitable for people with oily skin, acne-prone skin, enlarged pores, and dull skin." }
      ]}
    />
  );
}